import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Upload, Button, InputNumber, Row, Col, Tooltip, message, Spin } from 'antd';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, errorCatch, GET, Model, POST, QueryDetail, QueryOrder, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
// import PageLayout from '../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import MDEditor, { } from "@uiw/react-md-editor";
import ModernUserSelection from '../../components/ModernUserSelection';
import User from '../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


var _ = require('lodash');

const { Title } = Typography;

export default function AdministratoriPostov(props) {
    const { auth, object, system } = props;

    const filters = () => [
        {
            name: "administrator.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "administrator.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "administrator.patronymic",
            sort: true,
            filter: true,
        },

        {
            name: "administrator.email",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "administrator.phone",
            sort: true,
            filter: true,
        },
        {
            name: "administrator.gender",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            label: "Дата создания",
            name: "administrator.createdAt",
            type: "date",
            sort: true,
            filter: true,
        },
    ];

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<div key={item.ID || idx} style={{ width: "100%" }}>
            <div>
                <User item={item?.administrator} noborder={true} />
            </div>
        </div>)
    }

    // POST "/api/administratoripostov/create"
    // "/api/administratoripostov/delete/{id}"
    // "/api/administratoripostov/list/{masterid}"
    // "/api/administratoripostov/byid/{id}"

    return (
        <div>
            {object && <CollectionServer
                auth={auth}
                name={"AdministratoriPostov"}
                // queryDetail={"collection"}
                source={`/api/administratoripostov/list/${object?.ID}`}
                filters={filters}
                size={"small"}
                mode={"list"}
                render={render}

                collectionActions={() => [{
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        POST(auth, `/api/administratoripostov/create`, {
                            administratorID: values?.createrpostsID,
                            masterPostovID: object?.ID
                        },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data, true));
                                close();
                            }, (err) => errorCatch(err, unlock)
                        );
                    },
                    title: "Создать",
                    modal: {
                        title: "Создание администратора",
                        width: "650px"
                    },
                    form: Model,
                    meta: [
                        {
                            label: "Создатель постов",
                            name: "createrposts",
                            type: "object",
                            mode: "dialog",
                            modal: { width: "650px" },
                            relation: {
                                uiFilter: () => [
                                    {
                                        label: "Идентификатор пользователя",
                                        name: "ID",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "lastname",
                                        sort: true,
                                        filter: true,
                                        sorted: "ASC"
                                    },
                                    {
                                        name: "firstname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "patronymic",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "email",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Телефон",
                                        name: "phone",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "gender",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Дата регистрации",
                                        name: "createdAt",
                                        type: "date",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Дата назначения",
                                        name: "createdAt",
                                        type: "date",
                                        sort: true,
                                        filter: true,
                                    }
                                ],
                                displayString: (item) => {
                                    return item?.lastname + " " + item?.firstname
                                },
                                display: (item) => {
                                    return (
                                        <div key={item.ID} style={{ width: "100%", padding: "2px 5px", marginBottom: "5px" }}>
                                            <User item={item} noborder={true} />
                                        </div>
                                    )
                                },
                                reference: { object: "User", property: "ID", source: "/api/vsetipipolzovatelei/createrpostslist/users" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("combobox")
                            ]
                        }
                    ]
                }]}
                modelActions={(item) => {
                    return [
                        {
                            auth: auth,
                            title: <span style={{ color: "red" }}>Удалить</span>,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                confirmKey({
                                    pass: '123',
                                    title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить администратора</span>,
                                    icon: undefined,
                                    content: <div>
                                        <div>Вы действительно хотите удалить администратора?</div>
                                        <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.zagolovok} </div>
                                    </div>,
                                    okText: 'Удалить',
                                    cancelText: 'Отмена',
                                    onOk() {
                                        return new Promise((resolve, reject) => {
                                            GET(auth, '/api/administratoripostov/delete/' + item.ID,
                                                ({ data }) => {
                                                    setCollection(deleteInArray(collection, item));
                                                    resolve(data);
                                                }, (err) => errorCatch(err, reject));
                                        }).catch(() => { });
                                    },
                                    onCancel() {
                                    },
                                })
                            }
                        }
                    ]
                }}
            />}
        </div>
    );
}
